module.exports = __webpack_public_path__ + "static/img/steps_app2.2ecd17b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/steps_app2.png
// module id = 337
// module chunks = 1